<template>
  <div class="cell-summary-dialog">
    <vs-popup
      :title="popupTitle"
      :active.sync="showPopupByColumnKey"
      id="vs_edit_cell_popup"
      class="pm-popup"
      :class="[ ( popupColumnKey === 'vessel' ? 'pm-popup-vessel' : null ), ]"
    >

      <!-- オーダー種別 -->
      <div v-if="popupColumnKey === 'order_type'">
        <dialog-order-type
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-order-type>
      </div>

      <!-- オーダー時刻 -->
      <div v-if="popupColumnKey === 'order_at'">
        <dialog-order-at
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-order-at>
      </div>

      <!-- 進捗 -->
      <div v-if="popupColumnKey === 'progress'">
        <dialog-progress
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-progress>
      </div>

      <!-- 進捗時 -->
      <div v-if="popupColumnKey === 'progress_at'">
        <dialog-progress-at
          :showPopup="showPopup"
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-progress-at>
      </div>

      <!-- バース -->
      <div v-if="popupColumnKey === 'berth'">
        <dialog-berth
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-berth>
      </div>

      <!-- 車両 -->
      <div v-if="popupColumnKey === 'vehicles'">
        <dialog-vehicles
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-vehicles>
      </div>

      <!-- タグボート -->
      <div v-if="popupColumnKey === 'tug_boats'">
        <dialog-tug-boats
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-tug-boats>
      </div>

      <!-- 人数 -->
      <div v-if="popupColumnKey === 'head_count'">
        <dialog-head-count
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-head-count>
      </div>

      <!-- 綱ボート -->
      <div v-if="popupColumnKey === 'rope_boats'">
        <dialog-rope-boats
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-rope-boats>
      </div>

      <!-- 舷 -->
      <div v-if="popupColumnKey === 'boardside_type'">
        <dialog-boardside-type
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-boardside-type>
      </div>

      <!-- 旗 -->
      <div v-if="popupColumnKey === 'flag'">
        <dialog-flag
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-flag>
      </div>

      <!-- ビット -->
      <div v-if="popupColumnKey === 'bit'">
        <dialog-bit
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-bit>
      </div>

      <!-- 水先案内人 -->
      <div v-if="popupColumnKey === 'pilot'">
        <dialog-pilot
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-pilot>
      </div>

      <!-- 班長 -->
      <div v-if="popupColumnKey === 'team_leader'">
        <dialog-team-leader
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-team-leader>
      </div>

      <!-- 注意事項 -->
      <div v-if="popupColumnKey === 'caution_note'">
        <dialog-caution-note
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-caution-note>
      </div>

      <!-- 天候 -->
      <div v-if="popupColumnKey === 'weather'">
        <dialog-weather
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-weather>
      </div>

      <!-- 船舶＋タスク詳細 -->
      <div v-if="popupColumnKey === 'vessel'">
        <dialog-port-vessel
          :showPopup="showPopup"
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-port-vessel>
      </div>

      <div v-if="popupColumnKey === 'previous'">
        <dialog-berth
          columnKey="previous#berth_id"
          :valueMap="popupValueMap.berth"
          :taskId="popupTaskId"
          @updateValue="updateValue"
        >
        </dialog-berth>
      </div>

    </vs-popup>
  </div>
</template>

<script>
import DialogOrderType from "./DialogOrderType";
import DialogOrderAt from "./DialogOrderAt";
import DialogProgress from "./DialogProgress";
import DialogProgressAt from "./DialogProgressAt";
import DialogBerth from "./DialogBerth";
import DialogVehicles from "./DialogVehicles";
import DialogTugBoats from "./DialogTugBoats";
import DialogHeadCount from "./DialogHeadCount";
import DialogRopeBoats from "./DialogRopeBoats";
import DialogBoardsideType from "./DialogBoardsideType";
import DialogFlag from "./DialogFlag";
import DialogBit from "./DialogBit";
import DialogPilot from "./DialogPilot";
import DialogTeamLeader from "./DialogTeamLeader";
import DialogCautionNote from "./DialogCautionNote";
import DialogWeather from "./DialogWeather";
import DialogPortVessel from "./DialogPortVessel";

import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMasterDestinationWork");
const { mapState: mapStateOfPortMaster } = createNamespacedHelpers("portMaster");

export default {
  props: {
    showPopup:      { type: Boolean, required: true },
    clickX:         { type: Number,  required: true },
    clickY:         { type: Number,  required: true },
    popupTitle:     { type: String,  required: true },
    popupTaskId:    { type: String,  required: true },
    popupColumnKey: { type: String,  required: true },
    popupValueMap:  { required: true },
  },
  components: {
    DialogOrderType,
    DialogOrderAt,
    DialogProgress,
    DialogProgressAt,
    DialogBerth,
    DialogVehicles,
    DialogTugBoats,
    DialogHeadCount,
    DialogRopeBoats,
    DialogBoardsideType,
    DialogFlag,
    DialogBit,
    DialogPilot,
    DialogTeamLeader,
    DialogCautionNote,
    DialogWeather,
    DialogPortVessel,
  },
  data() {
    return {
      showPopupByColumnKey: false,
    };
  },
  watch: {
    showPopup() {
      if (this.showPopup === true) {
        this.showDialogByColumnKey();
      }
    },
    showPopupByColumnKey(){
      if (this.showPopupByColumnKey === false) {
        this.$emit("update:showPopup", false);
      }
    }
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
    }),
    ...mapStateOfPortMaster({
      selectedPort: state => state.selectedPort,
    }),    
  },
  methods: {
    ...mapActions(["updateFirestoreDocument"]),
    showDialogByColumnKey() {
      if (
        (this.popupColumnKey === 'caution_note' && ( !this.popupValueMap.value || this.popupValueMap.value.length === 0 )) || 
        (this.popupColumnKey === 'previous' && this.popupValueMap.order_type != '3')
      ) {
        // 注意事項が無い場合はポップアップは出さない。オーダーがシフトのとき以外は前泊地ポップアップは出さない。
        this.$emit("update:showPopup", false);
        return;
      }

      const vsEditCellPopup = document.getElementById('vs_edit_cell_popup');
      const vsPopup = vsEditCellPopup.querySelector("div.vs-popup");

      const popupDefaultWidth = Math.floor(document.documentElement.clientWidth * 5 / 12);
      const popupDefaultHeight = Math.floor(window.innerHeight / 2);

      if( this.popupColumnKey !== 'vessel' ) {
        vsPopup.style.position = 'absolute';
        if ( this.clickX + popupDefaultWidth <  document.documentElement.clientWidth  ) {
          vsPopup.style.left = this.clickX + 'px';
        } else {
          vsPopup.style.left = ( document.documentElement.clientWidth - popupDefaultWidth - 30 )  + 'px';
        }
        if ( this.clickY + popupDefaultHeight <  document.documentElement.clientHeight  ) {
          vsPopup.style.top = ( this.clickY + 30 ) + 'px';
        } else {
          vsPopup.style.top = (document.documentElement.clientHeight - popupDefaultHeight - 30) + 'px';
        }
        vsPopup.style.width = popupDefaultWidth + 'px';
        vsPopup.style.height = '';
      } else {
        // 船舶詳細は、他よりも情報量が多いので、特殊指定。
        vsPopup.style.left = '';
        vsPopup.style.top = '';
        vsPopup.style.width = '60rem';
        vsPopup.style.height = '';
      }

      this.showPopupByColumnKey = true;
    },
    async updateValue(...args) {
      // 更新登録処理の本体。 
      // enterprisePort x taskId x ( columnKey = value ) の指定方法で Firestoreの該当列に書き込んでいる。

      const [taskId, updateKeyValueMap, mode] = args; // 個々のダイアログからは共通的なフォーマットで受領する。

      let updateData = {
        enterprisePort: this.selectedPort,
        taskId: taskId,
        data: updateKeyValueMap,
        updateMode: mode ? mode.includes("update") : false,
        updateTimeStamp: mode ? mode.includes("updateTimeStamp") : false,
      };

      Vue.$log.debug("updateData", updateData);
      try {
        await this.updateFirestoreDocument(updateData);
        this.$emit('updateGridCell', updateData);
      } catch (e) {
        this.$vs.notify({
          title: "サーバ側の登録処理に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
          position: "bottom-center",
        });
      }

      this.showPopupByColumnKey = false;
    },
   },
  mounted() {
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";

.pm-popup {
  user-select: none; /* 選択を禁止する */
  .vs-popup {
    background-color: $pm-white !important;
  }
  header {
    h3 {
      text-align: center;
      background-color: $pm-white;
    }
    i {
      border-radius: 2rem;
      border: 0.15rem solid $pm-black;
      font-weight: bold;
    }
    background-color: $pm-white;
  }
  .outer-area {
    padding: 1rem;
  }
  .save-button {
    margin: 0 1rem;
    width: 30%
  }
  .vs-popup--close {
    background-color: $pm-white !important;
    transform: translate(-10px,10px);
    &:hover {
      transform: translate(-10px,8px);
    }
  }
}

.pm-popup-vessel {
  .vs-popup {
    background-color: #E0E0E0 !important;
    &--content {
      padding-top:0 !important;
    }
  }
  header {
    h3 {
      background-color: #E0E0E0;
    }
    background-color: #E0E0E0;
  }
  .vs-popup--close {
    background-color: #E0E0E0 !important;
  }
}
</style>

